import { LoadableTypography } from "@faire/deprecated-retailer-visitor-shared/components/GhostLoading/LoadableTypography";
import { Row } from "@faire/web/slate/Layout";
import React from "react";

interface IBrandCatalogSizeTextProps {
  brandToken: string | undefined;
  text: string | undefined;
  isLoaded: boolean;
}

export const BrandCatalogSizeText: React.FC<IBrandCatalogSizeTextProps> = ({
  brandToken,
  text,
  isLoaded,
}) => {
  const catalogSizeTextSection = (
    <Row align="center">
      <LoadableTypography
        isLoaded={isLoaded}
        variant="paragraphSansRegular"
        maxLines={1}
        className="break-all"
      >
        <span>{text}</span>
      </LoadableTypography>
    </Row>
  );

  if (!brandToken || !text) {
    return null;
  }

  return <Row justify="space-between">{catalogSizeTextSection}</Row>;
};
